package com.exura.features.userprofile.data.repository

import com.exura.features.userprofile.domain.repository.ProviderProfileRepository
import com.exura.features.firebase.domain.repository.UserPrefixedRepository
import com.exura.features.firebase.usecase.GetUserDataPrefixUseCase
import com.exura.features.userprofile.domain.model.ProviderProfile
import com.exura.features.userprofile.domain.repository.BaseProviderProfileRepository

class ProviderProfileRepositoryImpl(
    baseRepository: BaseProviderProfileRepository,
    getUserDataPrefixUseCase: GetUserDataPrefixUseCase,
) : ProviderProfileRepository, UserPrefixedRepository<ProviderProfile, ProviderProfile>(
    baseRepository = baseRepository,
    getDataPrefix = suspend { getUserDataPrefixUseCase() },
    collectionName = "userprofile"
)
